const doc = [({"da":({"js":({"admin":({"contact_relationships":({"edit":({"new_relationship":"Ny relation", "edit_relationship":"Rediger relation"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;